"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InputNumber = function (props) {
    var _a = React.useState("" + props.value), value = _a[0], setValue = _a[1];
    var comma = function (n) {
        return (Math.round(n * 1000) / 1000).toLocaleString();
    };
    var inputAttr = {};
    if (props.placeholder)
        inputAttr.placeholder = props.placeholder;
    if (props.id)
        inputAttr.id = props.id;
    if (props.className)
        inputAttr.className = props.className;
    var onChanged = function (e) {
        var valueStr = e.target.value;
        var value = Number(valueStr.replace(/[^\d.]+/g, ''));
        if (props.maxValue && value > props.maxValue) {
            console.log('over max price');
        }
        else {
            setValue(valueStr);
            if (valueStr) {
                props.onValueChanged(value);
            }
        }
    };
    var onFocus = function (e) {
        e.target.select();
    };
    var onKeyDown = function (e) {
        if (e.keyCode === 13 && props.onEnterPressed) {
            props.onEnterPressed();
        }
    };
    React.useEffect(function () {
        setValue("" + props.value);
    }, [props.value]);
    var valueStr = value === "-1" && props.unlimitedStr ? props.unlimitedStr : value;
    var valueComma = Number(valueStr).toString() === valueStr ? comma(Number(valueStr)) : valueStr;
    return (React.createElement("input", __assign({ onKeyDown: onKeyDown, value: valueComma }, inputAttr, { onChange: onChanged, onFocus: onFocus })));
};
exports.default = InputNumber;
